import {debounce} from "lodash";
import AnimateHelper from "./vanilla/AnimateHelper";

// Modules
import user from './sections/user/store'

let store = {
    state : {
        cart : {
            items              : [],
            repeating          : [],
            discountBreakdown  : {
                voucherCode : 0,
                promotion   : 0,
            },
            delivery           : {
                price : 0,
            },
            credit             : {
                price : 0,
            },
            guest              : true,
            promoCode          : '',
            codeMessage        : '',
            subscribe_discount : 0,
            vat                : 0,
            email              : '',
            rewardPoints       : 0,
            loading            : false,
        },
    },

    mutations : {
        refreshCart(state, cart)
        {
            if (Object.keys(cart).length > 0) {
                state.cart = cart;
            }

            Vue.set(state.cart, 'loading', false);

            window.dispatchEvent((new Event('cart-loaded')));
        },
        email(state, email)
        {
            state.cart.email = email;
        },
        loading(state, loading)
        {
            Vue.set(state.cart, 'loading', loading);
        }
    },

    getters : {
        cartCount          : state => {
            let count = 0;

            // Get a count of each line quantity
            Object.values(state.cart.items).forEach((item) => {
                count += parseInt(item.quantity);
            });

            return count;
        },
        totalLessDiscounts : state => {
            let total = state.cart.subtotal - state.cart.discount - state.cart.subscribe_discount;

            if (state.cart.trade) {
                total = total + state.cart.vat;
            }

            return total;
        },
    },

    actions : {
        refreshCart({commit})
        {
            axios
                .get('/cart/ajax')
                .then(response => {
                    commit('refreshCart', response.data)
                    commit('loading', false);
                });
        },
        adjustItemQuantity({dispatch, commit}, {type, item, event = null})
        {
            switch (type) {
                case 'increaseQty' :
                    item.quantity++;
                    break;

                case 'decreaseQty' :
                    item.quantity--;
                    break;

                case 'updateQty':
                    item.quantity = event.target.value;
                    break;
            }

            // Don't let it go below 1
            if (item.quantity <= 0) {
                item.quantity = 1;
            }

            dispatch('debounceItemUpdate', {item : item, event : event});
        },
        addItem({dispatch, commit}, item)
        {
            const payload = {
                'repeatingWeeks' : 0,
                'quantity'       : 1,
                'uom'            : item.display_price.Unit_of_Measure_Code,
                'no'             : item.No,
                'name'           : item.web_item.Name,
                'category'       : item.web_item.category_name,
                'price'          : item.display_price.Unit_Price_Inc_VAT,
                'brand'          : item.brand,
            };

            // Defines a new datalayer object variable for the 'Add to cart' event when adding a product from the cart upsell component.

            let cartAnalyticsValues = {
                'event'         : 'add_to_cart',
                'eventCategory' : 'ecommerce',
                'eventAction'   : 'add_to_cart',
                'ecommerce'     : {
                    'currencyCode' : item.currencyCode,
                    'add'          : {
                        'actionField' : {'list' : 6},
                        'products' : [item.treatImpression],
                    }
                }
            };

            new AnimateHelper('treat' + item.No, "pulse-5").animate();

            axios
                .post('/cart/item/add/' + item.id, payload)
                .then(response => {
                    new AnimateHelper("cart-items", "fade-in-10").animate();

                    commit('refreshCart', response.data);

                    dispatch('addToCartAnalytics', cartAnalyticsValues);

                    window.dispatchEvent((new Event('refresh-delivery')));
                });
        },
        removeItem({dispatch, commit}, item)
        {
            if (this.state.cart.loading === true) {
                return;
            }

            axios
                .get('/cart/item/remove/' + item.id)
                .then(response => {
                    new AnimateHelper("cart-items", "fade-in-10").animate();

                    commit('refreshCart', response.data);

                    window.dispatchEvent((new Event('refresh-delivery')));

                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        clearCart({commit})
        {
            axios
                .get('/cart/clear')
                .then(response => {
                    new AnimateHelper("cart-items", "fade-in-10").animate();

                    commit('refreshCart', response.data);

                    window.dispatchEvent((new Event('refresh-delivery')));

                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        addToCartAnalytics({dispatch}, cartAnalyticsValues)
        {
            window.dataLayer.push(cartAnalyticsValues)
        },
        debounceItemUpdate : _.debounce(function(state, payload) {
            state.commit('loading', true);

            axios
                .post('/cart/item/update', payload.item)
                .then(response => {
                    state.commit('refreshCart', response.data);

                    window.dispatchEvent((new Event('refresh-delivery')));
                })
                .catch(function(error) {
                    console.log(error);
                });
        }, 500, {leading : false, trailing : true}),
    },
    modules: {
        user
    }
};

export default store;
